import { IProperty, IPropertyWithType, PropertyMetadata } from "./properties.js";


export type Vec2Like = { x: number; y: number; };
export function isVec2Like(obj: IProperty): obj is IPropertyWithType<Vec2Like> {
    const val = obj.value;
    if (!val) return false;
    if (typeof val !== "object") return false;
    return 'x' in val && 'y' in val;
}

export type Vec3Like = { x: number; y: number; z: number; };
export function isVec3Like(obj: IProperty): obj is IPropertyWithType<Vec3Like> {
    const val = obj.value;
    if (!val) return false;
    if (typeof val !== "object") return false;
    return 'x' in val && 'y' in val && 'z' in val;
}


export type Vec4Like = { x: number; y: number; z: number; w: number; };
export function isVec4Like(obj: IProperty): obj is IPropertyWithType<Vec4Like> {
    const val = obj.value;
    if (!val) return false;
    if (typeof val !== "object") return false;
    return 'x' in val && 'y' in val && 'z' in val && 'w' in val;
}

export function isVectorPropertyLike(obj: IProperty): obj is IPropertyWithType<Vec2Like | Vec3Like | Vec4Like> {
    return isVec2Like(obj) || isVec3Like(obj) || isVec4Like(obj);
}
export function isVectorLike(obj: any): obj is Vec2Like | Vec3Like | Vec4Like {
    if (!obj) return false;
    if (typeof obj !== "object") return false;
    return ('x' in obj) && ('y' in obj) && (('z' in obj) || ('w' in obj) || true);
}

export type RGBColorLike = { r: number; g: number; b: number; };
export function isRGBColorPropertyLike(obj: IProperty): obj is IPropertyWithType<RGBColorLike> {
    const val = obj.value;
    return isRGBColorLike(val);
}
export function isRGBColorLike(obj: any): obj is RGBColorLike {
    if (!obj) return false;
    if (typeof obj !== "object") return false;
    return 'r' in obj && 'g' in obj && 'b' in obj;
}

export type RGBAColorLike = { r: number; g: number; b: number; a: number; };
export function isRGBAColorPropertyLike(obj: IProperty): obj is IPropertyWithType<RGBAColorLike> {
    const val = obj.value;
    return isRGBAColorLike(val);
}
export function isRGBAColorLike(obj: any): obj is RGBAColorLike {
    if (!obj) return false;
    if (typeof obj !== "object") return false;
    return 'r' in obj && 'g' in obj && 'b' in obj && 'a' in obj;
}

export type ColorLike = RGBColorLike | RGBAColorLike;
export function isColorPropertyLike(obj: IProperty): obj is IPropertyWithType<ColorLike> {
    return isRGBColorPropertyLike(obj) || isRGBAColorPropertyLike(obj);
}
export function isColorLike(obj: any): obj is ColorLike {
    return isRGBColorLike(obj) || isRGBAColorLike(obj);
}

export type ThreeObjectLike = import("three").Object3D;
export function isThreeObjectLike(obj: IProperty): obj is IPropertyWithType<import("three").Object3D> {
    const val = obj.value;
    if (!val) return false;
    if (typeof val !== "object") return false;
    return 'uuid' in val && 'type' in val && 'name' in val && 'children' in val && 'matrix' in val && 'position' in val && 'quaternion' in val && 'scale' in val;
}
export function isTextureLike(obj: any): obj is import("three").Texture {
    if (!obj) return false;
    if (typeof obj !== "object") return false;
    return 'uuid' in obj && 'image' in obj && 'wrapS' in obj && 'wrapT' in obj && 'magFilter' in obj && 'minFilter' in obj;
}

export function isTexturePropertyLike(obj: IProperty): obj is IPropertyWithType<import("three").Texture | null> {
    const val = obj.value;
    if (!val) return false;
    if (typeof val !== "object") return false;
    return isTextureLike(val);
}


// #region Test property accept types
export function propertyAcceptsNull(obj: IProperty): boolean | undefined {
    return PropertyMetadata.testAccept(obj, "null");
}
export function propertyAcceptsImage(obj: IProperty): boolean | undefined {
    return PropertyMetadata.testAccept(obj, "image/*");
}
export function propertyAcceptsColor(obj: IProperty): boolean | undefined {
    return PropertyMetadata.testAccept(obj, "color/*");
}